import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";
import FourZeroFour from "../images/404.webp";

const NotFound = () => {
  return (
    <div className="notFound-container">
      <img src={FourZeroFour} alt="" className="notFound-img" />
      <p className="notFound-text">Somethig Wrong Here</p>
      <Link to="/" className="notFound-link">
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
